import React from 'react';

const Geolocation = (props) => {

    const requestIpLocation = async (cb) => {
        try {
            const res = await fetch('https://ipinfo.io/geo');
            const data = await res.json();
            cb(data.loc.split(','));
        } catch (e) {
            console.warn(e);
        }
    };

    const requestGeolocation = async (e) => {
        e.preventDefault();

        if (!navigator.geolocation) {
            return requestIpLocation();
        }
        const cords = await new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve([position.coords.latitude, position.coords.longitude]);
            }, () => requestIpLocation(resolve));
        });
        props.onGeolocation(cords);
    };

    return (
        <button
            type="button"
            className="button button--ghost search-field__icon-button search-field__geolocation"
            aria-label={props.label}
            onClick={requestGeolocation}
        >
            <span className="search-field__icon search-field__icon--location" aria-hidden="true" />
        </button>
    );
};

export default Geolocation;
